import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';

var contextLinkThemeNative = {
  backgroundColor: colors.lightGrey,
  rightIconColor: colors.fogGrey,
  leftIconColor: 'text',
  iconLeftMargin: 0,
  iconRightMargin: 0,
  divider: {
    height: 1,
    color: colors.cloudGrey
  },
  text: {
    color: 'text',
    size: 20
  }
};
var contextLinkDarkThemeNative = _extends({}, contextLinkThemeNative, {
  backgroundColor: colors.mineShaftGrey,
  rightIconColor: colors.octoberGrey,
  leftIconColor: 'text',
  divider: _extends({}, contextLinkThemeNative.divider, {
    color: colors.octoberGrey
  })
});

export { contextLinkDarkThemeNative, contextLinkThemeNative };
